export default __webpack_public_path__ + "img/9eddaa346155346d4603cdd8a27d323d.svg";